import { Services } from '@app/services/enums/services.enum';

export interface HelpItem {
    labelTranslationKey: string;
    linkTranslationKey: string;
}

export const helpItems: { [key: string]: HelpItem[] } = {
    [Services.EnergyStop]: [
        {
            labelTranslationKey: 'V2.SERVICES.ENERGY_STOP.SUBMITTED.HELP.STILL_GETTING_ADVANCE_INVOICES.LABEL',
            linkTranslationKey: 'V2.SERVICES.ENERGY_STOP.SUBMITTED.HELP.STILL_GETTING_ADVANCE_INVOICES.LINK',
        },
        {
            labelTranslationKey: 'V2.SERVICES.ENERGY_STOP.SUBMITTED.HELP.FINAL_INVOICE_INCORRECT.LABEL',
            linkTranslationKey: 'V2.SERVICES.ENERGY_STOP.SUBMITTED.HELP.FINAL_INVOICE_INCORRECT.LINK',
        },
        {
            labelTranslationKey: 'V2.SERVICES.ENERGY_STOP.SUBMITTED.HELP.ANOTHER_QUESTION.LABEL',
            linkTranslationKey: 'V2.SERVICES.ENERGY_STOP.SUBMITTED.HELP.ANOTHER_QUESTION.LINK',
        },
    ],
    [Services.WaterNewContract]: [
        {
            labelTranslationKey: 'V2.SERVICES.WATER_NEW_CONTRACT.SUBMITTED.HELP.CONTRACT_NOT_STARTED_YET.LABEL',
            linkTranslationKey: 'V2.SERVICES.WATER_NEW_CONTRACT.SUBMITTED.HELP.CONTRACT_NOT_STARTED_YET.LINK',
        },
        {
            labelTranslationKey: 'V2.SERVICES.WATER_NEW_CONTRACT.SUBMITTED.HELP.NO_WATER_INVOICES.LABEL',
            linkTranslationKey: 'V2.SERVICES.WATER_NEW_CONTRACT.SUBMITTED.HELP.NO_WATER_INVOICES.LINK',
        },
        {
            labelTranslationKey: 'V2.SERVICES.WATER_NEW_CONTRACT.SUBMITTED.HELP.ANOTHER_QUESTION.LABEL',
            linkTranslationKey: 'V2.SERVICES.WATER_NEW_CONTRACT.SUBMITTED.HELP.ANOTHER_QUESTION.LINK',
        },
    ],
    [Services.WaterFinalInvoice]: [
        {
            labelTranslationKey: 'V2.SERVICES.WATER_FINAL_INVOICE.SUBMITTED.HELP.STILL_RECEIVING_INVOICES.LABEL',
            linkTranslationKey: 'V2.SERVICES.WATER_FINAL_INVOICE.SUBMITTED.HELP.STILL_RECEIVING_INVOICES.LINK',
        },
        {
            labelTranslationKey: 'V2.SERVICES.WATER_FINAL_INVOICE.SUBMITTED.HELP.FINAL_INVOICE_WRONG.LABEL',
            linkTranslationKey: 'V2.SERVICES.WATER_FINAL_INVOICE.SUBMITTED.HELP.FINAL_INVOICE_WRONG.LINK',
        },
        {
            labelTranslationKey: 'V2.SERVICES.WATER_FINAL_INVOICE.SUBMITTED.HELP.ANOTHER_QUESTION.LABEL',
            linkTranslationKey: 'V2.SERVICES.WATER_FINAL_INVOICE.SUBMITTED.HELP.ANOTHER_QUESTION.LINK',
        },
    ],
};
